import { Close, Pause } from '@mui/icons-material';
import { IconButton, Typography } from '@mui/material';
import PlayIcon from 'assets/images/icons/play.svg';
import { useEffect, useState } from 'react';
import SoundWave from 'views/dashboard/Default/SoundWave';

const CustomMediaPlay = ({ audioPlayer, deleteImage, removeImage, isDelete, isFile, index }) => {
    const [media, setMedia] = useState(new Audio(audioPlayer));
    const [duration, setDuration] = useState('0:00');
    const [totalDuration, setTotalDuration] = useState('0:00'); // New state for total duration
    const [play, setPlay] = useState(false);
    const [restartPlayer, setRestartPlayer] = useState(false);
    const [previouslyStarted, setPreviouslyStart] = useState(false);

    // Function to format time in minutes and seconds
    function formatTime(seconds) {
        const minutes = Math.floor(seconds / 60);
        const remainingSeconds = Math.floor(seconds % 60);
        return `${minutes}:${remainingSeconds < 10 ? '0' : ''}${remainingSeconds}`;
    }

    const handleDelete = () => {
        if (isFile) deleteImage(index);
        else removeImage(index);
    };

    // Function to handle audio playback
    const playAudio = () => {
        if (audioPlayer) {
            if (!play) {
                setRestartPlayer(false);
                if (!previouslyStarted) {
                    setPreviouslyStart(true);
                }

                if (previouslyStarted) {
                    setPlay(true);
                    media.play();
                    setDuration(formatTime(media.currentTime));
                }
            } else {
                media.pause();
                setPlay(false);
                setDuration(formatTime(media.currentTime));
            }
        }
    };

    // Function to update the current time and check for audio end
    const timeUpdate = () => {
        setDuration(formatTime(media.currentTime));
        if (media.ended) {
            setPlay(false);
            setPreviouslyStart(false);
        }
    };

    // Effect to update restartPlayer state when previouslyStarted changes
    useEffect(() => {
        if (previouslyStarted) {
            setRestartPlayer(true);
        }
    }, [previouslyStarted]);

    // Effect to handle audio playback when restartPlayer or audioPlayer changes
    useEffect(() => {
        if (restartPlayer) {
            if (!play) {
                setPlay(true);
                media.play();
            }
            media.addEventListener('timeupdate', timeUpdate);
        }
    }, [restartPlayer, audioPlayer]);

    // Effect to cleanup media and remove event listener when unmounting
    useEffect(() => {
        setRestartPlayer(false);
        return () => {
            setPlay(false);
            setRestartPlayer(false);
            media.pause();
            media.removeEventListener('timeupdate', timeUpdate);
        };
    }, []);

    // Effect to set total duration once media metadata is loaded
    useEffect(() => {
        const handleLoadedMetadata = () => {
            setTotalDuration(formatTime(media.duration));
        };
        media.addEventListener('loadedmetadata', handleLoadedMetadata);
        return () => {
            media.removeEventListener('loadedmetadata', handleLoadedMetadata);
        };
    }, [media]);

    return (
        <div className="custom-media-player">
            <IconButton onClick={playAudio}>
                {!play ? <img src={PlayIcon} alt="play-button" /> : <Pause sx={{ fill: '#00214d', fontSize: '10px' }} />}
            </IconButton>
            <SoundWave className={`${play ? 'play' : null}`} />
            <Typography className="time-info-text">{play ? duration : totalDuration}</Typography>
            {isDelete && (
                <IconButton className="media-close" onClick={handleDelete} sx={{ marginLeft: 'auto' }}>
                    <Close />
                </IconButton>
            )}
        </div>
    );
};

export default CustomMediaPlay;
